// Configuración de la API
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_APPSERVER_API_URL,
  HTTP_URL: process.env.REACT_APP_APPSERVER_API_URL_HTTP,
  TIMEOUT: 60000, // 60 segundos (aumentado para dar más tiempo a las respuestas de OpenAI)
  OPENAI_TIMEOUT: 120000, // 120 segundos para llamadas específicas a OpenAI
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
};
